function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconClockBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon-clock-blue") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Desktop---Giving-History"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Giving-History---Pledge"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4-Copy-6"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3-Copy"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    d: "M11.93,8a.66.66,0,0,1,.7.62.66.66,0,0,1-.7.61H7.43a.65.65,0,0,1-.69-.61V4a.65.65,0,0,1,.69-.61.66.66,0,0,1,.7.61V8ZM8,0A8,8,0,1,1,0,8,8,8,0,0,1,8,0ZM8,14.3A6.3,6.3,0,1,0,1.7,8,6.31,6.31,0,0,0,8,14.3Z",
    style: {
      fill: "#2774ae"
    }
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClockBlue);
export default __webpack_public_path__ + "static/media/icon-clock-blue.3f5a7122bfa7631120abf2872b357f9b.svg";
export { ForwardRef as ReactComponent };